import React from 'react'
import { useHistory } from 'react-router-dom'
import { Text } from 'vvs-uikit'
import { getVvsGotchiQuestDetailPath } from 'config/constants/paths'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import { QuestSymbol } from 'state/vvsgotchi/models/quest'
import { isGoldDiggerDisabled } from 'state/vvsgotchi/quests/goldDigger'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { questSymbolToImageUrl, questSymbolToImagePadding } from 'views/VvsGotchi/config'
import { questSymbolId } from 'views/VvsGotchi/utils/quest'

import { NotOnboardedLabel, CompletedLabel } from './Labels'

import { GotchiTaskButton } from './styles'
import type { QuestButtonProps } from './types'

const DefaultQuestButton: React.FC<QuestButtonProps> = ({ quest, title, imageUrl, isOnboardButton }) => {
  const { isOnboarded } = useGotchiOwner()
  const history = useHistory()
  const onboardToUnlock = !isOnboarded && !isOnboardButton

  const isGoldDiggerAndDisabled = quest.symbol === QuestSymbol.GOLD_DIGGER && isGoldDiggerDisabled()

  const grayout = onboardToUnlock || isGoldDiggerAndDisabled

  return (
    <GotchiTaskButton
      grayout={grayout}
      onClick={() => {
        history.push(getVvsGotchiQuestDetailPath(questSymbolId(quest.symbol)))
      }}
    >
      {onboardToUnlock ? <NotOnboardedLabel /> : quest.isCompleted && !isGoldDiggerAndDisabled && <CompletedLabel />}
      <PixelatedImage
        src={imageUrl ?? questSymbolToImageUrl[quest.symbol] ?? '/images/vvsGotchi/mole_controller.png'}
        alt={title ?? quest.name}
        height="80px"
        padding={questSymbolToImagePadding[quest.symbol]}
        grayout={grayout}
      />
      <Text color="black" width="100%" textAlign="left" bold mt={1}>
        {title ?? quest.name}
      </Text>
    </GotchiTaskButton>
  )
}

export default DefaultQuestButton
